export default "__VITE_ASSET__Cc83PYP1__"